
import "./SolutionsPage.css";
import SolutionOverview from "./SolutionOverview";
import BannerImage from "../../../assets/other_image/change_management.jpg";
import Letsgetintouch from "./Letsgetintouch";
import { NavLink } from "react-router-dom";
import React, { useEffect, useState } from "react";
import Banner from "../Banner/Banner";
import FloatingContactUs from "../../floting_contact/FloatingContactUs" 
const SolutionsPage = () => {

  return (
    <section className="business-process">
      
        <Banner
        image={BannerImage} // Pass the image for this page
        heading="Teamcenter Business Process & Change management" // Pass the heading text for this page
      />
    
      <div>
         <FloatingContactUs />
      </div>
      
      <SolutionOverview />

      <section style={{ background: "#f5f7fa" }}>
        <div className="benefits container">
          <h4 className="solution-page-heading">Unlock the Power :</h4>
          <h5 className="solution-subheading">
            Discover the Transformative Benefits of Business Process with NexTech !
          </h5>
          <ul className="custom-bullets">
            <li>
              Most up-to-date information and instructions to accomplish the job
              in time and with quality{" "}
            </li>
            <li>Enforcement of best practices and elimination of errors </li>
            <li>
              Improved understanding of change impact, decrease quality gaps
            </li>
            <li>
              Avoid costly overruns and delays with a clear change process
              across domains{" "}
            </li>
            <li>
              Improved product quality across the lifecycle to deliver
              high-quality products{" "}
            </li>
            <li>Proactive in preventing non-conformance </li>
          </ul>
        </div>
      </section>

      <section>
  <div className="solutions container">
    <div className="solutions-content">
      <div className="row">
        <div className="col-md-6 col-12">
          <h4 className="solution-page-heading">Teamcenter Solutions</h4>
          <ul className="custom-bullets">
            <li>Digital Workflow Management</li>
            <li>Change Management</li>
            <li>Issue Management</li>
            <li>CAPA (Corrective and Preventive Action)</li>
            <li>Quality Management</li>
          </ul>
        </div>

        <div className="col-md-6 col-12">
          <div className="quick-links">
            <h4>Quick Links</h4>
            <ul>
              <li><NavLink to={"/teamcenter/plm-document-management"} >Document Management</NavLink></li>
              <li><NavLink to={"/teamcenter/manufacturing-data-process-management"} >Manufacturing Data and Process Management</NavLink></li>
              <li><NavLink to={"/teamcenter/product-bom-variability-management"} >Product BOM and Variability Management</NavLink></li>
              <li><NavLink to={"/teamcenter/community-collaboration"} >Teamcenter Community Collaboration</NavLink></li>
              <li><NavLink to={"/teamcenter/cloud-implementation"} >Teamcenter Implementation on Cloud</NavLink></li>
              <li><NavLink to={"/teamcenter/ecad-integration"} >ECAD Integration</NavLink></li>
              <li><NavLink to={"/teamcenter/mcad-integration"} >MCAD Integration</NavLink></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


      <section style={{ background: "#f5f7fa" }}>
        <div className="why-nextech container">
          <h4 className="solution-page-heading">Why NexTech?</h4>
          <h5 className="solution-subheading">
            For Business Processes & Change Management Solution
          </h5>
          <ul className="custom-bullets">
            <li>
              Implementation of digital workflow management systems tailored to
              automate simple to complex PLM processes, ensuring efficient task
              completion and adherence to timelines.
            </li>
            <li>
              Comprehensive change management solutions facilitating the
              management of changes from identification through field support,
              achieving an end-to-end closed-loop change process and minimizing
              errors.
            </li>
            <li>
              Issue Management & CAPA solutions designed to prevent
              non-conformance by capturing complaints, defects, and
              non-conformance across the organization, enhancing product quality
              and regulatory compliance.
            </li>
            <li>
              Offerings include digital workflow management, change management,
              issue management, CAPA (Corrective and Preventive Action), and
              quality management, providing a holistic approach to business
              process optimization.
            </li>
            <li>
              Proactive approach in enforcing best practices, improving change
              impact understanding, decreasing quality gaps, and avoiding costly
              overruns and delays through clear change processes and improved
              product quality across the lifecycle.
            </li>
          </ul>
        </div>
      </section>

      <Letsgetintouch />
      
    </section>
  );
};

export default SolutionsPage;
